import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function urlValidator(): ValidatorFn {
  const urlRegex = /^(https?:\/\/)((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|(localhost))(\/.*)?$/;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    return urlRegex.test(control.value) ? null : { invalidUrl: true };
  };
}
